/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 资金管理模块接口</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2026年09月22日</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	//资金账户
	account: {
		list(params = {}) {
			return Ajax.get('/funds-account', params)
		},
		save(p) {
			return Ajax.post('/funds-account', p)
		},
		update(p) {
			return Ajax.put('/funds-account', p)
		},
		delete(id) {
			return Ajax.delete(`/funds-account/${id}`)
		}
	},
	//收支分类
	category: {
		list(params = {}) {
			return Ajax.get('/funds-category', params)
		},
		save(p) {
			return Ajax.post('/funds-category', p)
		},
		update(p) {
			return Ajax.put('/funds-category', p)
		},
		delete(id) {
			return Ajax.delete(`/funds-category/${id}`)
		}
	},
	//资金日记账
	journal: {
		list(params = {}) {
			return Ajax.get('/funds-journal', params)
		},
		save(p) {
			return Ajax.post('/funds-journal', p)
		},
		update(p) {
			return Ajax.put('/funds-journal', p)
		},
		delete(id) {
			return Ajax.delete(`/funds-journal/${id}`)
		},
		//生成凭证
		generateVoucher(id) {
			return Ajax.post(`/funds-journal/generateVoucher/${id}`)
		}
	},
	//内部转账
	transfer: {
		list(params = {}) {
			return Ajax.get('/funds-transfer', params)
		},
		save(p) {
			return Ajax.post('/funds-transfer', p)
		},
		update(p) {
			return Ajax.put('/funds-transfer', p)
		},
		delete(id) {
			return Ajax.delete(`/funds-transfer/${id}`)
		},
		generateVoucher(id) {
			return Ajax.post(`/funds-transfer/generateVoucher/${id}`)
		},
		//导入模板下载地址
		template() {
			return `/api/funds-transfer/template`
		},
		//Excel 导入
		importData(formData) {
			return Ajax.post(`/funds-transfer/import`, formData,
				{'Content-Type': 'multipart/form-data'})
		}
	},
	//资金报表（专业版报表）
	report(params = {}) {
		return Ajax.get('/pro-report/funds-report', params)
	},
	//核对总账（专业版报表）
	checkGeneral(params = {}) {
		return Ajax.get('/pro-report/check-general', params)
	}
};
